import { useState } from "react";
import classes from "./AuthPage.module.scss";
import AuthSlide from "../../components/slides/AuthPage/AuthSlide";
import { EmblaOptionsType } from "embla-carousel";
import { motion } from "motion/react";
import { useTheme } from "../../context/ThemeContext";
import { IconButton, Tooltip } from "@mui/material";
import DarkMode from "@mui/icons-material/DarkMode";
import LightMode from "@mui/icons-material/LightMode";

// Forms
import Login from "./Forms/Login";
import Signup from "./Forms/Signup";
import ForgotPassword from "./Forms/ForgotPassword";

// Assets
import Footer from "../../components/layout/Footer";
import logo from "../../assets/images/auth-logo.png";
import discover from "../../assets/slides/discover.png";
import connect from "../../assets/slides/connect.png";
import network from "../../assets/slides/network.png";

const OPTIONS: EmblaOptionsType = { loop: true };
const SLIDES = [
    { image: discover, text: "Expand your professional network and build valuable relationships" },
    {
        image: connect,
        text: "Become part of a thriving Muslim community and unlock new career opportunities",
    },
    {
        image: network,
        text: "Join us to connect with top professionals and unlock new career opportunities. Start your journey to success today!",
    },
];

const AuthPage = () => {
    const [activeForm, setActiveForm] = useState<string>("login");
    const { isDarkMode, toggleDarkMode } = useTheme();

    const handleFormChange = (form: string) => setActiveForm(form);

    return (
        <div className={classes.container}>
            {/* Theme Toggle */}
            <div className={classes.themeToggleContainer}>
                <Tooltip title={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}>
                    <IconButton
                        onClick={toggleDarkMode}
                        className={classes.themeToggle}
                        aria-label="toggle dark mode"
                    >
                        {isDarkMode ? <LightMode /> : <DarkMode />}
                    </IconButton>
                </Tooltip>
            </div>

            {/* Left side with carousel (only on Desktop) */}
            <div className={classes.leftSide}>
                <div className={classes.authSlide}>
                    <AuthSlide slides={SLIDES} options={OPTIONS} />
                </div>
            </div>

            {/* Right Side with form */}
            <div className={classes.rightSide}>
                {/* Logo at the top */}
                <div className={classes.logoContainer}>
                    <img src={logo} alt="MAX Aspire Logo" className={classes.logo} />
                </div>

                {/* Animated Form Section */}
                <div className={classes.form}>
                    {activeForm === "signup" ? (
                        <motion.div
                            key="signup"
                            initial={{ x: "100%", opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            exit={{ x: "-100%", opacity: 0 }}
                        >
                            <Signup onClickLogin={handleFormChange} />
                        </motion.div>
                    ) : activeForm === "forgotpassword" ? (
                        <motion.div
                            key="forgotpassword"
                            initial={{ x: "100%", opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            exit={{ x: "-100%", opacity: 0 }}
                        >
                            <ForgotPassword
                                onClickSignup={handleFormChange}
                                onClickLogin={handleFormChange}
                            />
                        </motion.div>
                    ) : (
                        <motion.div
                            key="login"
                            initial={{ x: "100%", opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            exit={{ x: "-100%", opacity: 0 }}
                        >
                            <Login onClickSignup={handleFormChange} />
                        </motion.div>
                    )}
                </div>

                {/* Footer at the bottom */}
                <div className={classes.footer}>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default AuthPage;
